import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import {
  CadastrarServicoBodyModel,
  IEditServico,
  IPatchServico
} from './servico.model';

@Injectable({
  providedIn: 'root'
})
export class ServicoService {
  constructor(private http: HttpClient) {}

  CreateServico(
    body: CadastrarServicoBodyModel,
    guid: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      IdempotencyKey: guid
    });

    return this.http.post<any>(
      `${environment.baseURL}Servico/CreateServico`,
      body,
      { headers: headers }
    );
  }

  public EditarServico(pkServico: number, body: IEditServico): Observable<any> {
    const url = `${environment.baseURL}Servico/UpdateServico?id=${pkServico}`;

    return this.http.put<any>(url, body);
  }

  public GetServico(
    fl_agendamento?: boolean,
    status: number = 1
  ): Observable<any> {
    const url = `${environment.baseURL}Servico/GetServicos`;
    const params: any = {};

    if (fl_agendamento === false || fl_agendamento === true) {
      params.FL_AGND = fl_agendamento;
    }
    params.NU_STTS_ALL = status;
    return this.http.get<any>(url, { params });
  }

  public GetServicoById(id?: number): Observable<any> {
    let url = `${environment.baseURL}Servico/GetServicoById`;
    if (id !== undefined) {
      url += `?id=${id}`;
    }
    return this.http.get<any>(url);
  }

  public PatchServico(servicoId: number, body: IPatchServico): Observable<any> {
    const url = `${environment.baseURL}Servico/PatchServicoStatus?id=${servicoId}`;
    return this.http.patch(url, body);
  }
}
